import { axiosPost, axiosGet } from "../react_axios/Axios";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

// export const BASE_URL = "http://localhost:9000";

//3.11...............................................
// export const BASE_URL = "http://103.25.126.207:8105/api";
// export const REPORT_BASE_URL = `http://103.25.126.207:8105/doc`;

// uat
// export const BASE_URL = "https://awards_uat.india-itme.com/api";
// export const REPORT_BASE_URL = `https://awards_uat.india-itme.com/doc`;
// export const LOGIN_URL='https://awards_uat.india-itme.com/#';

//beta
// export const BASE_URL='https://awards-beta.india-itme.com/api';
// export const LOGIN_URL='https://awards-beta.india-itme.com/#';
// export const REPORT_BASE_URL='https://awards-beta.india-itme.com/doc';

//uat and beta only
export const LOGIN_URL = `https://${window.location.host}/#`;
export const BASE_URL = `https://${window.location.host}/api`;
export var REPORT_BASE_URL = `https://${window.location.host}/doc`;

//prod
// export const LOGIN_URL = 'https://awards.india-itme.com/#';
// export const BASE_URL = 'https://awards.india-itme.com/api';
// export const REPORT_BASE_URL = 'https://awards.india-itme.com/doc';
// ..............................................................

export const user_id = sessionStorage.getItem("user_id") != "" ? sessionStorage.getItem("user_id") : null
export const award_event_id = sessionStorage.getItem("award_event_id") != "" ? sessionStorage.getItem("award_event_id") : null
export const jury_id = sessionStorage.getItem("jury_id") != "" ? sessionStorage.getItem("jury_id") : null
export const role_id = sessionStorage.getItem("role_id") != "" ? sessionStorage.getItem("role_id") : null

export const responseError = (data) => {
  if (data.msg == "Session expired! Please login again." || data.msg == "Token invalid") {
    //after session expire.....................
    sessionStorage.clear();
    this.props.navigate("/");
    setTimeout(() => {
      toastError(data.msg);
    }, 2000);
  } else {
    toastError(data.data);
  }
};
// prod url with HTTPS.....................................................
// export var BASE_URL = `https://${window.location.host}/api`;
// prod url with HTTP only.....................................................
// export var BASE_URL = `http://${window.location.host}/api`;

// link for Download submitted undertaking for uat

export const fetchAuthReport = `${REPORT_BASE_URL}/report/SetParameterData`;
export const downloadReport = `${REPORT_BASE_URL}/WebForm/ItmeReportViewer.aspx`;

// export const reportName = "ExhibitorRegistration.rpt";
// export const bonafideDocName = "bonafideCertificate.rpt";

// auth
export const loginUrl = `${BASE_URL}/auth/loginUser`;
export const changePasswordUrl = `${BASE_URL}/auth/changePassword`;
export const forgetPasswordUrl = `${BASE_URL}/auth/forgetPassword`;
export const signUpUrl = `${BASE_URL}/auth/signUp`;
export const verifyOtpUrl = `${BASE_URL}/auth/verifyOtp`;
export const manageUserLoginSessionUrl = `${BASE_URL}/auth/manageUserLoginSession`;


export const sendPaymentFormUrl = `${BASE_URL}/payment/sendSmartPaymentForm`;

//jury profile
export const juryProfileListUrl = `${BASE_URL}/admin-juryProfile/juryProfilesList`;
export const insertUpdatejuryProfileUrl = `${BASE_URL}/admin-juryProfile/insertUpdatejuryProfile`;
export const juryProfileDetailUrl = `${BASE_URL}/admin-juryProfile/getjuryProfileDetails`;
export const juryProfileDeleteUrl = `${BASE_URL}/admin-juryProfile/deletejuryProfile`;
export const jurySeqChangeUrl = `${BASE_URL}/admin-juryProfile/jurySeqChange`;

//security
//roles
export const roleListUrl = `${BASE_URL}/admin-roles/rolesList`;
export const insertUpdateRoleUrl = `${BASE_URL}/admin-roles/insertUpdateRole`;
export const roleDetailUrl = `${BASE_URL}/admin-roles/getRoleDetails`;
export const roleDeleteUrl = `${BASE_URL}/admin-roles/deleteRole`;
// user
export const getUserListUrl = `${BASE_URL}/admin-user/getUserList`;
export const getUserDetailsUrl = `${BASE_URL}/admin-user/getUserDetails`;
export const addUpdateUserUrl = `${BASE_URL}/admin-user/addUpdateUser`;
export const deleteUserUrl = `${BASE_URL}/admin-user/deleteUser`;
export const suspendUserUrl = `${BASE_URL}/admin-user/suspendUser`;

//Common
export const getFillListUrl = `${BASE_URL}/fillList/getFillList`;
export const getHdrDtlUrl = `${BASE_URL}/header/getHdrDtl`;
export const getDashboardDataUrl = `${BASE_URL}/dashboard/getDashboardData`;
//award Query
export const getAwardQuerywithAnswerCommentsUrl = `${BASE_URL}/awardQuery/getAwardQuerywithAnswerComments`;
export const insertUpdateAwardQueryUrl = `${BASE_URL}/awardQuery/insertUpdateAwardQuery`;
export const insertUpdateAwardAnswerUrl = `${BASE_URL}/awardQuery/insertUpdateAwardAnswer`;
export const insertUpdateAwardCommentUrl = `${BASE_URL}/awardQuery/insertUpdateAwardComment`;

// reports
export const getReportListUrl = `${BASE_URL}/reports/getReportList`;
export const reportDetailListUrl = `${BASE_URL}/reports/reportDetailList`;
export const getDynamicReportUrl = `${BASE_URL}/reports/getDynamicReport`;
export const getDynamicFillListUrl = `${BASE_URL}/reports/getDynamicFillList`;
//Awards
export const insertMilestoneMasterUrl = `${BASE_URL}/admin-awards/insertMilestoneMaster`
//awardEvent
export const getAwardEventListUrl = `${BASE_URL}/admin-awards/getAwardEventList`
export const AwardEventDetailUrl = `${BASE_URL}/admin-awards/awardEventDetails`
export const IUAwardEventMilestoneUrl = `${BASE_URL}/admin-awards/insertUpdateAwardEventMilestone`
export const IUAwardEventJuryUrl = `${BASE_URL}/admin-awards/insertUpdateAwardEventJury`
export const deleteAwardEventUrl = `${BASE_URL}/admin-awards/deleteAwardEvent`;
//awardProfile
export const AwardProfileDetailUrl = `${BASE_URL}/admin-awards/awardProfileDetails`
export const insertUpdateAwardProfileUrl = `${BASE_URL}/admin-awards/insertUpdateAwardProfile`
export const insertUpdateAwardProfileApplicationSectionUrl = `${BASE_URL}/admin-awards/insertUpdateAwardProfileApplicationSection`
export const insertUpdateAwardProfileScoringPatternUrl = `${BASE_URL}/admin-awards/insertUpdateAPScoringPattern`
export const insertUpdateAwardProfileMilestoneUrl = `${BASE_URL}/admin-awards/insertUpdateAwardProfileMilestone`
export const deleteAwardProfileUrl = `${BASE_URL}/admin-awards/deleteAwardProfile`
export const awardProfileFormPublishUrl = `${BASE_URL}/admin-awards/awardProfileFormPublish`
export const insertUpdateAwardProfileApplicationFeeUrl = `${BASE_URL}/admin-awards/insertUpdateAwardProfileApplicationFee`
export const AwardProfileChangeSeqUrl = `${BASE_URL}/admin-awards/awardProfileChangeSeq`

//admin module
export const getAdminApplicationListUrl = `${BASE_URL}/admin/getAdminApplicationList`
export const verifyApplicationFormUrl = `${BASE_URL}/admin/verifyApplicationForm`
export const getAdminApplicationMatrixListUrl = `${BASE_URL}/admin/getAdminApplicationMatrixList`
export const getAdminJuryBriefingListUrl = `${BASE_URL}/admin/getAdminJuryBriefingList`
export const addUpdateJuryBriefingUrl = `${BASE_URL}/admin/addUpdateJuryBriefing`
export const getApplicationQueryListUrl = `${BASE_URL}/admin/getApplicationQueryList`
export const insertUpdateApplicationFormSuvinScoringUrl = `${BASE_URL}/admin/insertUpdateApplicationFormSuvinScoring`

// Application Form
export const getApplicationFormDefaultDetailsUrl = `${BASE_URL}/applicant-applicationForm/getApplicationFormDefaultDetails`
export const getApplicantPaymentDetailsUrl = `${BASE_URL}/applicant-applicationForm/getApplicantPaymentDetails`
export const getApplicationFormDetailsUrl = `${BASE_URL}/applicant-applicationForm/getApplicationFormDetails`
export const getApplicantPricingUrl = `${BASE_URL}/applicant-applicationForm/getApplicantPricing`
export const insertUpdateApplicationFormUrl = `${BASE_URL}/applicant-applicationForm/insertUpdateApplicationForm`

// Circular 
export const getCircularCompantUrl = `${BASE_URL}/admin-circular/getCircularCompany`
export const getCircularListUrl = `${BASE_URL}/admin-circular/getCircularList`
export const insertCircularUrl = `${BASE_URL}/admin-circular/insertCircular`
export const deleteCircularUrl = `${BASE_URL}/admin-circular/deleteCircular`
export const assignCircularUrl = `${BASE_URL}/admin-circular/assignCircular`

//accounts
//proforma
export const getProformaListUrl = `${BASE_URL}/proforma/getProformaList`
export const insertUpdateProformaUrl = `${BASE_URL}/proforma/insertUpdateProforma`

//taxInvoice
export const getTaxInvoiceListUrl = `${BASE_URL}/taxInvoice/getTaxInvoiceList`

//receipt
export const receiptUpdateUrl = `${BASE_URL}/receipt/updateReceipt`;
export const receiptListUrl = `${BASE_URL}/receipt/fetchReceiptList`;
export const proformaInvoiceUrl = `${BASE_URL}/receipt/getProformaInvoice`;
export const receiptDetailsUrl = `${BASE_URL}/receipt/getReceiptDetails`;
export const generateVoucherUrl = `${BASE_URL}/receipt/generateVoucher`;
export const receiptAddUrl = `${BASE_URL}/receipt/addReceipt`;
export const shareOutstandingEmailUrl = `${BASE_URL}/receipt/shareOutstandingEmail`;
export const receiptNoUrl = `${BASE_URL}/receipt/getReceiptNo`;
export const receiptSaveUrl = `${BASE_URL}/receipt/addReceipt`;
export const getEmailDataUrl = `${BASE_URL}/receipt/getEmailData`;
export const receiptDelUrl = `${BASE_URL}/receipt/delReceipt`;
export const getPendingReceiptDetailsUrl = `${BASE_URL}/receipt/getpendingreceipt`;
export const receiptShareUrl = `${BASE_URL}/receipt/receiptShare`;

//jury Module
//jury dashboard
export const juryReviewApplicationListUrl = `${BASE_URL}/jury/getJuryReviewApplicationList`
export const getJuryApplicationQueryUrl = `${BASE_URL}/jury/getJuryApplicationQuery`
export const insertUpdateJuryQueryUrl = `${BASE_URL}/jury/insertUpdateJuryQuery`
export const getJuryReviewScoringPatternUrl = `${BASE_URL}/jury/getJuryReviewScoringPattern`
export const insertUpdateJuryReviewScoringUrl = `${BASE_URL}/jury/insertUpdateJuryReviewScoring`
// Current Award Details
export const getCurrentAwardDetailsUrl = `${BASE_URL}/currentAwardDetails/getCurrentAwardDetails`
export const getActiveJuryDetailsUrl = `${BASE_URL}/currentAwardDetails/getActiveJuryDetails`

// application matrix
export const getApplicationMatrixListUrl = `${BASE_URL}/applicationMatrix/getApplicationMatrixList`
export const updateShortlistFinalistMatrixUrl = `${BASE_URL}/applicationMatrix/updateShortlistFinalistMatrix`

//notification
// application matrix
export const getAwardQueryNotificationUrl = `${BASE_URL}/notification/getAwardQueryNotification`
export const awardQuerySeenArchiveUrl = `${BASE_URL}/notification/awardQuerySeenArchive`
export const awardQuerySeenArchiveAllUrl = `${BASE_URL}/notification/awardQuerySeenArchiveAll`

//cms
export const getCmsContentUrl = `${BASE_URL}/cms/getCmsContent`
export const IUCmsContentUrl = `${BASE_URL}/cms/insertUpdateCMSContent`
export const IUCmsContentSectionUrl = `${BASE_URL}/cms/insertUpdateCMSContentSection`
export const IUCmsMenuUrl = `${BASE_URL}/cms/insertUpdateCMSMenu`
export const IUCmsFooterUrl = `${BASE_URL}/cms/insertUpdateCMSFooter`
export const IUCmsBannerUrl = `${BASE_URL}/cms/insertUpdateCMSBanner`
export const IUCmsSubheaderUrl = `${BASE_URL}/cms/insertUpdateCMSSubheader`
export const PublishCmsContentUrl = `${BASE_URL}/cms/publishCMSContent`
export const PublishCmsMenuUrl = `${BASE_URL}/cms/publishCMSMenu`
export const PublishCmsFooterUrl = `${BASE_URL}/cms/publishCMSFooter`
export const PublishCmsBannerUrl = `${BASE_URL}/cms/publishCMSBanner`
export const PublishCmsSubheaderUrl = `${BASE_URL}/cms/publishCMSSubheader`
export const updateCMSContentStatusUrl = `${BASE_URL}/cms/updateCMSContentStatus`
export const deleteCMSMenuUrl = `${BASE_URL}/cms/deleteCMSMenu`
export const deleteCMSStaticFilesUrl = `${BASE_URL}/cms/deleteCMSStaticFiles`
export const insertUpdateCMSStaticUploadsUrl = `${BASE_URL}/cms/insertUpdateCMSStaticUploads`


//  platform  name  const platform = window.navigator.platform
export const platform = window.navigator.platform;
export const headers = {
  Accept: "application/json, text/plain, */*", // It can be used to overcome cors errors
  "Content-Type": "application/json",
};

// registrationDeskListUrl, platform, REGISTRATION_DESK_LIST_ACTION_TYPE,

//action type start.....................
//common
//dashboard
export const GET_DASHBOARD_DATA_ACTION_TYPE = "GET_DASHBOARD_DATA"
//query
export const GET_AWARD_QUERY_WITH_ANSWER_COMMENTS_ACTION_TYPE = "GET_AWARD_QUERY_WITH_ANSWER_COMMENTS"
export const INSERT_UPDATE_AWARD_QUERY_ACTION_TYPE = "INSERT_UPDATE_AWARD_QUERY"
export const INSERT_UPDATE_AWARD_ANSWER_ACTION_TYPE = "INSERT_UPDATE_AWARD_ANSWER"
export const INSERT_UPDATE_AWARD_COMMENT_ACTION_TYPE = "INSERT_UPDATE_AWARD_COMMENT"

// login
export const LOGIN_ACTION_TYPE = "LOGIN";
export const CHANGE_PASSWORD_ACTION_TYPE = "CHANGE_PASSWORD_ACTION_TYPE";
export const FORGET_PASSWORD_ACTION_TYPE = "FORGET_PASSWORD_ACTION_TYPE";
export const SIGNUP_ACTION_TYPE = "SIGNUP_ACTION_TYPE";
export const VERIFY_OTP_ACTION_TYPE = "VERIFY_OTP_ACTION_TYPE";
export const MANAGE_USER_LOGIN_SESSION_ACTION_TYPE = "MANAGE_USER_LOGIN_SESSION_ACTION_TYPE";

export const SEND_PAYMENT_FORM = "SEND_PAYMENT_FORM"


//jury profile
export const JURY_PROFILE_LIST_ACTION_TYPE = "JURY_PROFILE_LIST";
export const INSERT_UPDATE_JURY_PROFILE_ACTION_TYPE =
  "INSERT_UPDATE_JURY_PROFILE";
export const DELETE_JURY_PROFILE_ACTION_TYPE = "DELETE_JURY_PROFILE";
export const JURY_PROFILE_DETAILS_ACTION_TYPE = "JURY_PROFILE_DETAILS";
export const JURY_SEQ_CHANGE_ACTION_TYPE = "JURY_SEQ_CHANGE";

//security
//roles
export const ROLES_LIST_ACTION_TYPE = "ROLES_LIST";
export const INSERT_UPDATE_ROLES_ACTION_TYPE = "INSERT_UPDATE_ROLES";
export const DELETE_ROLE_ACTION_TYPE = "DELETE_ROLE";
export const ROLE_DETAILS_ACTION_TYPE = "ROLE_DETAILS";
// User
export const GET_USER_LIST_ACTION_TYPE = "GET_USER_LIST_ACTION_TYPE";
export const GET_USER_DETAILS_ACTION_TYPE = "GET_USER_DETAILS_ACTION_TYPE";
export const ADD_UPDATE_USER_ACTION_TYPE = "ADD_UPDATE_USER_ACTION_TYPE";
export const DELETE_USER_ACTION_TYPE = "DELETE_USER_ACTION_TYPE";
export const SUSPEND_USER_ACTION_TYPE = "SUSPEND_USER_ACTION_TYPE";

//fill LIST
export const GET_FILL_LIST_ACTION_TYPE = "GET_FILL_LIST_ACTION_TYPE";
export const GET_HDR_DTL_ACTION_TYPE = "GET_HDR_DTL_ACTION_TYPE";

//Reports
export const GET_REPORT_DETAIL = "GET_REPORT_DETAIL";
export const GET_REPORT_LIST = "GET_REPORT_LIST";
export const GET_DYNAMIC_REPORT = "GET_DYNAMIC_REPORT";
export const GET_DYNAMIC_FILLLIST = "GET_DYNAMIC_FILLLIST";

//AWARDS
export const INSERT_MILESTONE_MASTER_ACTION_TYPE = "INSERT_MILESTONE_MASTER";
//awardEvent
export const AWARD_LIST_ACTION_TYPE = "AWARD_LIST";
export const AWARD_EVENT_DETAILS_ACTION_TYPE = "AWARD_EVENT_DETAILS";
export const IU_AWARD_EVENT_MILESTONE_ACTION_TYPE = "IU_AWARD_EVENT_MILESTONE";
export const IU_AWARD_EVENT_JURY_ACTION_TYPE = "IU_AWARD_EVENT_JURY";
export const DELETE_AWARD_EVENT_ACTION_TYPE = "DELETE_AWARD_EVENT";
//awardProfile
export const AWARD_PROFILE_DETAILS_ACTION_TYPE = "AWARD_PROFILE_DETAILS";
export const IU_AWARD_PROFILE_ACTION_TYPE = "IU_AWARD_PROFILE";
export const IU_AWARD_PROFILE_APPLICATION_SECTION_ACTION_TYPE = "IU_AWARD_PROFILE_APPLICATION_SECTION";
export const IU_AWARD_PROFILE_SCORING_PATTERN_ACTION_TYPE = "IU_AWARD_PROFILE_SCORING_PATTERN";
export const IU_AWARD_PROFILE_MILESTONE_ACTION_TYPE = "IU_AWARD_PROFILE_MILESTONE";
export const IU_AWARD_PROFILE_APPLICATION_FEE_ACTION_TYPE = "AWARD_PROFILE_APPLICATION_FEE";
export const DELETE_AWARD_PROFILE_ACTION_TYPE = "DELETE_AWARD_PROFILE";
export const AWARD_PROFILE_FORM_PUBLISH_ACTION_TYPE = "AWARD_PROFILE_FORM_PUBLISH";
export const AWARD_PROFILE_CHANGE_SEQ_ACTION_TYPE = "AWARD_PROFILE_CHANGE_SEQ";

//admin
export const GET_ADMIN_APPLICATION_LIST_ACTION_TYPE = "GET_ADMIN_APPLICATION_LIST"
export const VERIFY_APPLICATION_ACTION_TYPE = "VERIFY_APPLICATION"
export const GET_ADMIN_APPLICATION_MATRIX_LIST_ACTION_TYPE = "GET_ADMIN_APPLICATION_MATRIX_LIST"
export const GET_ADMIN_JURY_BRIEFING_LIST_ACTION_TYPE = "GET_ADMIN_JURY_BRIEFING_LIST"
export const ADD_UPDATE_JURY_BRIEFING_ACTION_TYPE = "ADD_UPDATE_JURY_BRIEFING"
export const GET_APPLICATION_QUERY_LIST_ACTION_TYPE = "GET_APPLICATION_QUERY_LIST"
export const INSERT_UPDATE_APPLICATION_FORM_SUVIN_SCORING_ACTION_TYPE = "INSERT_UPDATE_APPLICATION_FORM_SUVIN_SCORING"

// Application Form
export const GET_APPLICATION_FORM_DEFAULT_DETAILS_ACTION_TYPE = "GET_APPLICATION_FORM_DEFAULT_DETAILS_ACTION_TYPE";
export const GET_APPLICATION_FORM_DETAILS_ACTION_TYPE = "GET_APPLICATION_FORM_DETAILS_ACTION_TYPE";
export const GET_APPLICANT_PRICING_ACTION_TYPE = "GET_APPLICANT_PRICING_ACTION_TYPE";
export const INSERT_UPDATE_APPLICATION_FORM_ACTION_TYPE = "INSERT_UPDATE_APPLICATION_FORM_ACTION_TYPE";
export const GET_APPLICATION_PAYMENT_DETAILS = "GET_APPLICATION_PAYMENT_DETAILS";


// Circular
export const GET_CIRCULAR_COMPANY_ACTION_TYPE = "GET_CIRCULAR_COMPANY_ACTION_TYPE"
export const GET_CIRCULAR_LIST_ACTION_TYPE = "GET_CIRCULAR_LIST_ACTION_TYPE"
export const INSERT_CIRCULAR_ACTION_TYPE = "INSERT_CIRCULAR_ACTION_TYPE"
export const DEL_CIRCULAR_ACTION_TYPE = "DEL_CIRCULAR_ACTION_TYPE"
export const ASSIGN_CIRCULAR_ACTION_TYPE = "ASSIGN_CIRCULAR_ACTION_TYPE"

//accounts
//proforma
export const GET_PROFORMA_LIST_ACTION_TYPE = "GET_PROFORMA_LIST_ACTION_TYPE"
export const INSERT_UPDATE_PROFORMA_ACTION_TYPE = "INSERT_UPDATE_PROFORMA_ACTION_TYPE"
export const DOWNLOAD_PERFORMA_INVOICE = "DOWNLOAD_PERFORMA_INVOICE"

//taxInvoice
export const GET_TAXINVOICE_LIST_ACTION_TYPE = "GET_TAXINVOICE_LIST_ACTION_TYPE"
export const DOWNLOAD_TAXINVOICE_INVOICE = "DOWNLOAD_TAXINVOICE_INVOICE"

//receipt
export const RECEIPT_ENTRY_ACTION_TYPE = "RECEIPT_ENTRY_ACTION_TYPE";
export const RECEIPT_LIST_ACTION_TYPE = "RECEIPT_LIST_ACTION_TYPE";
export const PERFORMA_INVOICE_ACTION_TYPE = "PERFORMA_INVOICE_ACTION_TYPE";
export const RECEIPT_DETAILS_ACTION_TYPE = "RECEIPT_LIST_ACTION_TYPE";
export const RECEIPT_GENERATE_VOUCHER_ACTION_TYPE = "RECEIPT_GENERATE_VOUCHER_ACTION_TYPE";
export const SHARE_OUTSTANDING_EMAIL_ACTION_TYPE = "SHARE_OUTSTANDING_EMAIL_ACTION_TYPE";
export const RECEIPT_NUMBER_ACTION_TYPE = "RECEIPT_NUMBER_ACTION_TYPE";
export const GET_EMAIL_ACTION_TYPE = "GET_EMAIL_ACTION_TYPE";
export const RECEIPT_DEL_ACTION_TYPE = "RECEIPT_DEL_ACTION_TYPE";
export const RECEIPT_UPDATE_ACTION_TYPE = "RECEIPT_UPDATE_ACTION_TYPE";
export const PENDING_RECEIPT_DETAILS_ACTION_TYPE = "PENDING_RECEIPT_DETAILS_ACTION_TYPE"
export const GET_RECEIPT_PDF_ACTION_TYPE = "GET_RECEIPT_PDF_ACTION_TYPE"
export const RECEIPT_SHARE_ACTION_TYPE = "RECEIPT_SHARE_ACTION_TYPE"
export const DOWNLOAD_RECEIPT = "DOWNLOAD_RECEIPT"

//Jury
//jury dashboard
export const GET_JURY_REVIEW_APPLICATION_LIST_ACTION_TYPE = "GET_JURY_REVIEW_APPLICATION_LIST"
export const GET_JURY_APPLICATION_QUERY_ACTION_TYPE = "GET_JURY_APPLICATION_QUERY"
export const INSERT_UPDATE_JURY_QUERY_ACTION_TYPE = "INSERT_UPDATE_JURY_QUERY"
export const GET_JURY_REVIEW_SCORING_PATTERN_ACTION_TYPE = "GET_JURY_REVIEW_SCORING_PATTERN"
export const IU_JURY_REVIEW_SCORING_ACTION_TYPE = "IU_JURY_REVIEW_SCORING"

// application matrix
export const UPDATE_SHORTLIST_FINALIST_MATRIX_LIST = "UPDATE_SHORTLIST_FINALIST_MATRIX_LIST"
export const GET_APPLICATION_MATRIX_LIST = "GET_APPLICATION_MATRIX_LIST"

// Current Award Details
export const GET_CURRENT_AWARD_DETAILS_ACTION_TYPE = "GET_CURRENT_AWARD_DETAILS_ACTION_TYPE"
export const GET_ACTIVE_JURY_DETAILS_ACTION_TYPE = "GET_ACTIVE_JURY_DETAILS_ACTION_TYPE"

// Notification
export const GET_AWARD_QUERY_NOTIFICATION_ACTION_TYPE = "GET_AWARD_QUERY_NOTIFICATION_ACTION_TYPE"
export const AWARD_QUERY_SEEN_ARCHIVE_ACTION_TYPE = "AWARD_QUERY_SEEN_ARCHIVE_ACTION_TYPE"
export const AWARD_QUERY_SEEN_ARCHIVE_ALL_ACTION_TYPE = "AWARD_QUERY_SEEN_ARCHIVE_ALL_ACTION_TYPE"

//cms
export const GET_CMS_CONTENT_ACTION_TYPE = "GET_CMS_CONTENT_ACTION_TYPE"
export const IU_CMS_CONTENT_ACTION_TYPE = "IU_CMS_CONTENT_ACTION_TYPE"
export const IU_CMS_CONTENT_SECTION_ACTION_TYPE = "IU_CMS_CONTENT_SECTION_ACTION_TYPE"
export const IU_CMS_MENU_ACTION_TYPE = "IU_CMS_MENU_ACTION_TYPE"
export const IU_CMS_FOOTER_ACTION_TYPE = "IU_CMS_FOOTER_ACTION_TYPE"
export const IU_CMS_BANNER_ACTION_TYPE = "IU_CMS_BANNER_ACTION_TYPE"
export const IU_CMS_SUBHEADER_ACTION_TYPE = "IU_CMS_SUBHEADER_ACTION_TYPE"
export const PUBLISH_CMS_CONTENT_ACTION_TYPE = "PUBLISH_CMS_CONTENT_ACTION_TYPE"
export const PUBLISH_CMS_MENU_ACTION_TYPE = "PUBLISH_CMS_MENU_ACTION_TYPE"
export const PUBLISH_CMS_FOOTER_ACTION_TYPE = "PUBLISH_CMS_FOOTER_ACTION_TYPE"
export const PUBLISH_CMS_BANNER_ACTION_TYPE = "PUBLISH_CMS_BANNER_ACTION_TYPE"
export const PUBLISH_CMS_SUBHEADER_ACTION_TYPE = "PUBLISH_CMS_SUBHEADER_ACTION_TYPE"
export const UPDATE_CMS_CONTENT_STATUS_ACTION_TYPE = "UPDATE_CMS_CONTENT_STATUS_ACTION_TYPE"
export const DELETE_CMS_MENU_ACTION_TYPE = "DELETE_CMS_MENU_ACTION_TYPE"
export const DELETE_CMS_STATIC_FILES_ACTION_TYPE = "DELETE_CMS_STATIC_FILES_ACTION_TYPE"
export const IU_CMS_STATIC_UPLOADS_ACTION_TYPE = "IU_CMS_STATIC_UPLOADS_ACTION_TYPE"

//action type end..........................

// action ID name
export const roleActionId = "1";
export const countryActionId = "2"
export const juryActionId = "3"
export const milestoneAEActionId = "4"
export const categoryActionId = "5"
export const applicationTypeActionId = "6"
export const nominationProcessActionId = "7"
export const targetApplicantActionId = "8"
export const awardCategoryActionId = "9"
export const milestoneAPActionId = "10"
export const sectionAPActionId = "11"
export const dataTypeAPActionId = "12"
export const controlTypeAPActionId = "13"
export const mandatoryAPActionId = "14"
export const scoringModeActionId = "15"
export const scoringRoundActionId = "16"
export const scoringOptionsActionId = "17"
export const paymentTypeActionId = "18"
export const applicationStatusActionId = "18"
export const applicantTypeActionId = "19"
//receipt
export const voucherActionId = '20'
export const bankAccountActionId = '21'
export const paymentModeActionId = '22'
export const receiptAccountTypeActionId = '23'
export const applicantActionId = '24'
export const coordinatorListActionId = '25'
export const stateActionId = '26'
export const fileFormatActionId = '27'
export const applicantTypePricingActionId = '28'
export const seq_noActionId = '29'
export const juryApplicationStatusActionId = '30'
export const automatedTypeActionId = '31'
export const allApplicantActionId = '32'
export const pgViewChargesActionId = '40'


export const appVersion = "1.0.0";
export const buildNumber = "20220511";
export const NA = "NA";

// for clear search fields
export const clearsessionStorage = (pageName) => {
  if (pageName === "registrationDesk") {
  }
};

const registrationDeskSS = () => {
  sessionStorage.setItem("campIdRDSS", "Select");
  sessionStorage.setItem("campDateRDSS", "");
};

export const sort = (list, tableValue, isSort) => {
  isSort = !isSort;
  if (!isSort) {
    // sorting
    var sort = list.sort((a, b) => {
      const nameA = tableValue.toUpperCase(); // ignore upper and lowercase
      const nameB = tableValue.toUpperCase(); // ignore upper and lowercase
      if (nameA < nameB) {
        return -1;
      }
      if (nameA > nameB) {
        return 1;
      }
      return 0;
    });
    // this.setState({list : sort})
    var data = [sort, !sort];
    return data;
  } else {
    // reverse
    var sort = list.sort((a, b) => {
      const nameA = tableValue.toUpperCase(); // ignore upper and lowercase
      const nameB = tableValue.toUpperCase(); // ignore upper and lowercase
      if (nameA < nameB) {
        return 1;
      }
      if (nameA > nameB) {
        return -1;
      }
      return 0;
    });
    // this.setState({list : sort})
    var data = [sort, !sort];
    return data;
  }
  // this.setState({isToDateSort : !isToDateSort})
};

export const toastError = (msg) => {
  toast.error(msg, {
    theme: "colored",
    autoClose: 3000,
    hideProgressBar: true,
    position: "top-center",
  });
};

export const toastSuccess = (msg) => {
  toast.success(msg, {
    theme: "colored",
    autoClose: 3000,
    hideProgressBar: true,
    position: "top-center",
  });
};

export function timeout(delay) {
  return new Promise((res) => setTimeout(res, delay));
}


